
import React from 'react'

function Test({display}) {
  return (
    <div>I am {display} component</div>
  )
}

export default Test